var _excluded = ["image", "button"],
  _excluded2 = ["text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { rgba } from "polished";
import styled, { css } from "styled-components";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import ButtonAtm from "../../atoms/ButtonAtm";
import Picture from "../../quarks/Picture";
var HoverContainer = styled.div.withConfig({
  componentId: "sc-1f6a2qv-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:absolute;top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;background:", ";@media (hover:none){display:none;}"], rgba(getColor(theme, "backgroundLight"), 0.6));
});
var Container = styled.div.withConfig({
  componentId: "sc-1f6a2qv-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["display:inline-flex;position:relative;overflow:hidden;border-radius:", ";box-shadow:", ";&:not(:hover) ", "{display:none;}"], getBorderRadius(theme, "medium"), getBoxShadow(theme, "large"), HoverContainer);
});
function ImageTileLinkMol(_ref3) {
  var image = _ref3.image,
    button = _ref3.button,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var buttonText = button.text,
    restButtonProps = _objectWithoutProperties(button, _excluded2);
  return /*#__PURE__*/React.createElement(Container, restProps, /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  }), /*#__PURE__*/React.createElement(HoverContainer, null, /*#__PURE__*/React.createElement(ButtonAtm, _extends({
    color: "dark",
    isWider: true,
    isOverlappingRelativeContainer: true
  }, restButtonProps), buttonText)));
}
export default ImageTileLinkMol;